import { useGetShipmentsSuspense } from '@uturn/api/v3';
import { useShipmentsSearchStore } from '@uturn/portal/store/shipments/shipments-search';
import { useEffect, useMemo, useState } from 'react';
import { ShipmentsList } from './shipment-list';
import type { ShipmentsProps } from './shipment-page';

export const UngroupedShipments = ({
	shipmentsParams,
	details,
	EmptyState,
	hasQuotes,
}: ShipmentsProps) => {
	const { totalShipments, setPagination } = useShipmentsSearchStore();
	const [page, setPage] = useState(0);

	const { data: shipments, queryKey } = useGetShipmentsSuspense(
		{
			...shipmentsParams,
			page: page.toString(),
		},
		{
			query: {
				select: (data) => data.data,
			},
		},
	);

	const pageSize = useMemo(
		() => shipments.pageSize, // Rows on page
		[shipments.totalElements],
	);

	useEffect(() => {
		setPagination(shipments.totalElements, pageSize);
	}, [shipments.totalElements, pageSize, setPagination]);

	if (totalShipments === 0) {
		return <EmptyState />;
	}

	return (
		<ShipmentsList
			shipments={shipments.data}
			page={page}
			setPage={setPage}
			parentQueryKey={queryKey}
			details={details}
			hasQuotes={hasQuotes}
		/>
	);
};
